import { ScenarioChatFormSchema, type ScenarioChatForm } from '../types'
import * as v from 'valibot'

type ValidateByValibotResult =
  | {
      type: 'success'
    }
  | {
      type: 'error'
      errorMessages: string[]
    }

export function validateByValibot(
  values: ScenarioChatForm
): ValidateByValibotResult {
  const result = v.safeParse(ScenarioChatFormSchema, values)

  if (result.success) {
    return {
      type: 'success',
    }
  }

  const errorMessages = result.issues.flatMap<string>(issue => {
    if (issue.path == undefined) {
      return []
    }

    const rootPath = issue.path[0]

    switch (rootPath.key) {
      case 'title':
        return [`タイトル: ${issue.message}`]
      case 'messages':
        const messagePath = issue.path[1]
        // @ts-expect-error
        const forUserIndex = messagePath.value.forUserIndex

        return [`メッセージ[${forUserIndex}]: ${issue.message}`]
      default:
        console.error('不明なパス', issue)
        return []
    }
  })

  return {
    type: 'error',
    errorMessages,
  }
}
